// React
import React from "react";

// Libraries
import PropTypes from "prop-types";

// Components
import Text from "@Components/Text";

// Styles
import styles from "./styles.module.css";

const FilterBox = ({ title = "", count = 0, isSelected = false, position = "", onClick, className = "", withColor = false }) => {
	return (
		<div
			className={`${withColor && count > 0 ? styles.red : ""} ${isSelected ? styles.selectedBox : styles.box} ${
				styles[position]
			} ${className}`}
			role="button"
			tabIndex={-1}
			onClick={onClick}>
			<Text className={styles.boxText}>{`${count > 0 ? count : "-"}`}</Text>
			<Text className={styles.boxText}>{title}</Text>
		</div>
	);
};

FilterBox.propTypes = {
	title: PropTypes.string,
	count: PropTypes.number,
	isSelected: PropTypes.bool,
	withColor: PropTypes.bool,
	position: PropTypes.oneOf(["left", "right", "centerLeft", "centerRight", "center"]),
	onClick: PropTypes.func,
	className: PropTypes.string,
};

export default FilterBox;
